import React, { Component } from 'react';
import { Table, TableBody, TableCell, TableContainer, TableHead, TableRow } from '@mui/material';
import {
  Button, Card, FormControl, FormHelperText, InputLabel, MenuItem, Select, TablePagination, TextField, Tooltip
} from '@mui/material';
import { localGetItem } from '../../../../../Utility/Services/CacheProviderService';
import RestAPIService from '../../../../../Utility/Services/RestAPIService';
import { Serviceurls } from '../../../../../Utility/API/Serviceurls';
import { DateTime } from "luxon";
import Dialog from '../../../../../Components/Dialog';
import { Trans, withTranslation } from 'react-i18next';
import { Colors } from '../../../../../Styles/Colors';
import FilterListIcon from '@mui/icons-material/FilterList';
import KeyboardArrowUpIcon from '@mui/icons-material/KeyboardArrowUp';
import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown';
import Failed from '../../../../../Assets/Animation/Failed.gif'
import FutureDatePicker from '../../../../../Components/FutureDatepicker/FutureDatePicker';
import CloseIcon from '@mui/icons-material/Close';
import PaymentCard from '../../../../../Components/PaymentCard/PaymentCard';
import SearchIcon from '@mui/icons-material/Search';
import AccountBalanceIcon from '@mui/icons-material/AccountBalance';
import CurrencyRupeeIcon from '@mui/icons-material/CurrencyRupee';
import { DosageType } from "../../../../../Components/CommonFunctions/CommonFunctions"

class ExpiryStock extends Component {
  constructor(props) {
    super(props)
    this.state = {
      page: 0,
      rowsPerPage: 5,
      BrandNameSortOrder: 'asc',
      GenericNameSortOrder: 'asc',
      ExpiryDateSortOrder: 'asc',
      VendorSortOrder: 'asc',
      BrandNameSortIcon: 'none',
      ExpiryDateSortIcon: 'none',
      GenericNameSortIcon: 'none',
      VendorSortIcon: 'none',
      ExpiryStock: [],
      DefaultExpiryStock: [],
      dialogBox: false,
      SearchText: "",
      datefilter: 0,
      QueryFrmDte: "",
      QueryToDte: "",
      datePickerPop: false,
      PharmacyId: localGetItem("Pharmacy_Id")
    }
  }

  componentDidMount() {
    this.getExpiryStock();
  }

  getExpiryStock = () => {
    try {
      RestAPIService.getAll(Serviceurls.PHARMACY_REPORT_Expiry_Stock + `?pharmacy_id=${this.state.PharmacyId}&from_date=${this.state.QueryFrmDte}&to_date=${this.state.QueryToDte}`)
        .then(response => {
          this.setState({
            ExpiryStock: response.data.data,
            DefaultExpiryStock: response.data.data
          })
        })
        .catch(e => {
          this.setState({ dialogBox: true, ErrorMsg: e.message });
          setTimeout(() => {
            this.setState({
              dialogBox: false
            })
          }, 3000)
        });
    }
    catch (e) {
      this.setState({ dialogBox: true, ErrorMsg: e.message });
      setTimeout(() => {
        this.setState({
          dialogBox: false
        })
      }, 3000)
    }
  }

  //  Mui table Pagination Functions --- starts

  handleChangePage = (event, newPage) => {
    this.setState({ page: newPage });
  }

  handleChangeRowsPerPage = (event) => {
    this.setState({ rowsPerPage: +event.target.value, page: 0 });
  }

  //  Mui table Pagination Functions --- ends

  PopClose = () => {
    this.setState({
      datePickerPop: false,
      datefilter: 0,
      QueryFrmDte: "",
      QueryToDte: "",
    }, () => this.getExpiryStock())
  }

  CustomDates = (FromDate, ToDate) => {
    this.setState({
      QueryFrmDte: FromDate,
      QueryToDte: ToDate,
      datePickerPop: false
    }, () => this.getExpiryStock())
  }

  dialogCloseFunction = () => {
    this.setState({
      dialogBox: false
    })
  }

  DateHelperText = () => {
    if (this.state.datefilter === 0) {
      return " "
    }
    else if (this.state.datefilter === 1) {
      return DateTime.now().toFormat('dd-MM-yyyy')
    }
    else if (this.state.datefilter === 2) {
      return DateTime.now().minus({ days: 1 }).toFormat('dd-MM-yyyy')
    }
    else if (this.state.datefilter === 3) {
      return `${DateTime.now().minus({ days: 7 }).toFormat('dd-MM-yyyy')}  to  ${DateTime.now().toFormat('dd-MM-yyyy')}`
    }
    else if (this.state.datefilter === 4) {
      return `${DateTime.now().minus({ days: 30 }).toFormat('dd-MM-yyyy')}  to  ${DateTime.now().toFormat('dd-MM-yyyy')}`
    }
    else if (this.state.datefilter === 5) {
      return this.state.QueryToDte === undefined ? null : `${this.state.QueryFrmDte.split("-").reverse().join("-")}  to  ${this.state.QueryToDte.split("-").reverse().join("-")}`
    }
  }

  render() {
    const { t } = this.props

    // Sorting Function   ==== starts
    const sorting = (col, SortOrder) => {
      if (SortOrder === "asc") {
        const Sorted = [...this.state.ExpiryStock].sort((a, b) => {
          if (typeof (a[col]) == "string") {
            return a[col].toLowerCase() > b[col].toLowerCase() ? 1 : -1
          } else {
            return a[col] > b[col] ? 1 : -1
          }
        })
        this.setState({ ExpiryStock: Sorted })

        if (col === "brand_name") {
          this.setState({ BrandNameSortOrder: 'desc', ExpiryDateSortOrder: 'asc', VendorSortOrder: 'asc', GenericNameSortOrder: 'asc', BrandNameSortIcon: "asc", ExpiryDateSortIcon: "none", GenericNameSortIcon: 'none', VendorSortIcon: 'none', })
        }
        else if (col === "generic_name") {
          this.setState({ GenericNameSortOrder: 'desc', ExpiryDateSortOrder: 'asc', VendorSortOrder: 'asc', BrandNameSortOrder: 'asc', GenericNameSortIcon: "asc", ExpiryDateSortIcon: "none", BrandNameSortIcon: 'none', VendorSortIcon: 'none', })
        }
        else if (col === "expiry_date") {
          this.setState({ ExpiryDateSortOrder: 'desc', GenericNameSortOrder: 'asc', VendorSortOrder: 'asc', BrandNameSortOrder: 'asc', ExpiryDateSortIcon: "asc", GenericNameSortIcon: "none", BrandNameSortIcon: 'none', VendorSortIcon: 'none', })
        }
        else if (col === "vendor_name") {
          this.setState({ VendorSortOrder: 'desc', GenericNameSortOrder: 'asc', ExpiryDateSortOrder: 'asc', BrandNameSortOrder: 'asc', VendorSortIcon: "asc", GenericNameSortIcon: "none", BrandNameSortIcon: 'none', ExpiryDateSortIcon: 'none', })
        }

      }
      else if (SortOrder === "desc") {
        const Sorted = [...this.state.ExpiryStock].sort((a, b) => {
          if (typeof (a[col]) == "string") {
            return a[col].toLowerCase() < b[col].toLowerCase() ? 1 : -1
          } else {
            return a[col] < b[col] ? 1 : -1
          }
        })
        this.setState({ ExpiryStock: Sorted })

        if (col === "brand_name") {
          this.setState({ BrandNameSortOrder: 'default', BrandNameSortIcon: "desc" })
        }
        else if (col === "generic_name") {
          this.setState({ GenericNameSortOrder: 'default', GenericNameSortIcon: "desc" })
        }
        else if (col === "expiry_date") {
          this.setState({ ExpiryDateSortOrder: 'default', ExpiryDateSortIcon: "desc" })
        }
        else if (col === "vendor_name") {
          this.setState({ VendorSortOrder: 'default', VendorSortIcon: "desc" })
        }
      }
      else if (SortOrder === "default") {
        this.setState({
          BrandNameSortIcon: 'none',
          ExpiryDateSortIcon: 'none',
          GenericNameSortIcon: 'none',
          VendorSortIcon: 'none',
          BrandNameSortOrder: 'asc',
          GenericNameSortOrder: 'asc',
          ExpiryDateSortOrder: 'asc',
          VendorSortOrder: 'asc',
          ExpiryStock: this.state.DefaultExpiryStock
        })
      }
    }
    // Sorting Function   ==== ends


    //  Sorting Icons Change func === starts 
    const SortIcon = (sortType) => {
      if (sortType === "asc") {
        return <Tooltip disableInteractive placement='top' title={t("InAscendingOrder")}><KeyboardArrowUpIcon sx={{ color: Colors.SortIconColor }} id='eMed_sorting_icon' /></Tooltip>
      }
      else if (sortType === 'desc') {
        return <Tooltip disableInteractive placement='top' title={t("InDecendingOrder")}><KeyboardArrowDownIcon sx={{ color: Colors.SortIconColor }} id='eMed_sorting_icon' /></Tooltip>
      }
      else return <Tooltip disableInteractive placement='top' title={t("Sorting")}><FilterListIcon sx={{ color: Colors.SortIconColor }} id='eMed_sorting_icon' /></Tooltip>
    }

    //  Sorting Icons Change func === ends 


    //  filter table data based on search Text
    const filtereddata = this.state.ExpiryStock.filter((data) => {
      return (
        (data.brand_name === null ? null : data.brand_name.toLowerCase().includes(this.state.SearchText.toLowerCase())) ||
        (data.batch_no === null ? null : data.batch_no.toLowerCase().includes(this.state.SearchText.toLowerCase())) ||
        (data.dosage_strength === null ? null : data.dosage_strength.toLowerCase().includes(this.state.SearchText.toLowerCase())) ||
        (data.expiry_date === null ? null : data.expiry_date.includes(this.state.SearchText)) ||
        (data.vendor_name === null ? null : data.vendor_name.toLowerCase().includes(this.state.SearchText.toLowerCase())) ||
        (data.available_quantity === null ? null : Math.round(data.available_quantity * 100) === parseInt(Math.round(this.state.SearchText * 100)))
      );
    });

    //  Sorting Icons Change func === ends 

    const handleDate = () => {
      var today = DateTime.now().toFormat('yyyy-MM-dd')
      var yesterday = DateTime.now().minus({ days: 1 }).toFormat('yyyy-MM-dd')
      var startweek = DateTime.now().minus({ days: 7 }).toFormat('yyyy-MM-dd')
      var startmonth = DateTime.now().minus({ days: 30 }).toFormat('yyyy-MM-dd')

      if (this.state.datefilter === 0) {
        this.setState({
          QueryFrmDte: "",
          QueryToDte: "",
        }, () => {
          this.getExpiryStock()
        })
      }
      else if (this.state.datefilter === 1) {
        this.setState({
          QueryFrmDte: today,
          QueryToDte: today,
        }, () => {
          this.getExpiryStock()
        })

      }
      else if (this.state.datefilter === 2) {
        this.setState({
          QueryFrmDte: yesterday,
          QueryToDte: yesterday,
        }
          , () => {
            this.getExpiryStock()
          })
      }
      else if (this.state.datefilter === 3) {
        this.setState({
          QueryFrmDte: startweek,
          QueryToDte: yesterday,
        },
          () => {
            this.getExpiryStock()
          })
      }
      else if (this.state.datefilter === 4) {
        this.setState({
          QueryFrmDte: startmonth,
          QueryToDte: yesterday,
        },
          () => {
            this.getExpiryStock()
          })
      }
      else if (this.state.datefilter === 5) {
        this.setState({ datePickerPop: true })
      }
    }

    const handleChange = (event) => {
      this.setState({ datefilter: event.target.value }, () => handleDate());
    };

    return (
      <div>
        <div className="eMed_page_header">
          <div id='eMed_name_totalcard'>
            <div id='eMed_table_name' style={{ color: Colors.TextColor }}>{t(this.props.menuName)}</div>
            {/* --- Expiry Stock - PaymentCard - not in v3

             <div id='eMed_totalcard'>
              <PaymentCard Color={Colors.blue} Icons={<CurrencyRupeeIcon />} Name={t("Total Amount")} Amount="200" />
              <PaymentCard Color={Colors.orange} Icons={<AccountBalanceIcon />} Name={t("Total Quantity")} Amount="600" />
            </div> */}
          </div>
          <div id='eMed_tbl_filters'>
            <div>
              <FormControl id="eMed_tbl_datefilter">
                <InputLabel sx={{ color: Colors.TextColor }}>{t("SelectDate")}</InputLabel>
                <Select
                  sx={{ color: Colors.TextColor }}
                  size='small'
                  value={this.state.datefilter}
                  label={t("SelectDate")}
                  onChange={handleChange}
                >
                  <MenuItem value={0}>{t("All")}</MenuItem>
                  <MenuItem value={1}>{t("Today")}</MenuItem>
                  <MenuItem value={2}>{t("Yesterday")}</MenuItem>
                  <MenuItem value={3}>{t("Lastweek")}</MenuItem>
                  <MenuItem value={4}>{t("LastMonth")}</MenuItem>
                  <MenuItem value={5} onClick={() => this.setState({ datePickerPop: true })}>{t("Custom")}</MenuItem>
                </Select>
                <FormHelperText sx={{ color: Colors.HelperText }} id="eMed_form_helpertext">{this.DateHelperText()}</FormHelperText>
              </FormControl>
            </div>
            {this.state.SearchFieldOpen ?
              <div id="eMed_tbl_searchbox" >
                <TextField
                  size='small'
                  focused
                  onChange={(e) => this.setState({ SearchText: e.target.value })}
                  value={this.state.SearchText}
                  label={t("SearchHere")}
                  variant="outlined"
                  InputProps={{
                    endAdornment: (
                      <Tooltip disableInteractive title={t("Clear")} placement='top'><CloseIcon sx={{ color: Colors.ThemeColor }} onClick={() => { this.setState({ SearchText: '' }) }} /></Tooltip>
                    ),
                  }}
                />
              </div> : null}
            <Tooltip disableInteractive placement="top-start" title={this.state.SearchFieldOpen ? t("CloseSearch") : t("OpenSearch")}>
              <Button id="eMed_tbl_searchicon" variant='contained' style={{ backgroundColor: Colors.ThemeColor }} onClick={() => this.setState({ SearchFieldOpen: !this.state.SearchFieldOpen, CardOpen: false, SearchText: '' })} >
                {this.state.SearchFieldOpen ? <CloseIcon /> : <SearchIcon />}
              </Button>
            </Tooltip>
          </div>
        </div>
        <Card className='eMed_tbl_card' sx={{ bgcolor: Colors.TableCard }} >
          <TableContainer className='eMed_tbl_container'>
            <Table stickyHeader>
              <TableHead>
                <TableRow>
                  <TableCell className='eMed_tbl_headwidth_small id="eMed_nonsticky_head"' sx={{ bgcolor: Colors.TableHeaderBarBGColor, color: Colors.TableHeaderTextColor }}><div className='eMed_sortable_center' id="eMed_tbl_headtext">{t("S.No")}</div></TableCell>
                  <TableCell className='eMed_tbl_headwidth_small id="eMed_nonsticky_head"' sx={{ bgcolor: Colors.TableHeaderBarBGColor, color: Colors.TableHeaderTextColor }}>
                    <div className=' eMed_sortable_name'>
                      <div id="eMed_tbl_headtext">{t("VendorName")}</div>
                      <div onClick={() => { sorting("vendor_name", this.state.VendorSortOrder) }}>{SortIcon(this.state.VendorSortIcon)}</div>
                    </div>
                  </TableCell>
                  <TableCell className='eMed_tbl_headwidth_small' id="eMed_nonsticky_head" sx={{ bgcolor: Colors.TableHeaderBarBGColor, color: Colors.TableHeaderTextColor }}><div className='eMed_sortable_center' id="eMed_tbl_headtext">{t("BatchNo")}</div></TableCell>
                  <TableCell className='eMed_tbl_headwidth_small' sx={{ bgcolor: Colors.TableHeaderBarBGColor, color: Colors.TableHeaderTextColor }}>
                    <div className=' eMed_sortable_name'>
                      <div id="eMed_tbl_headtext">{t("BrandName")}</div>
                      <div onClick={() => { sorting("brand_name", this.state.BrandNameSortOrder) }}>{SortIcon(this.state.BrandNameSortIcon)}</div>
                    </div>
                  </TableCell>
                  <TableCell className='eMed_tbl_headwidth_small' id="eMed_nonsticky_head" sx={{ bgcolor: Colors.TableHeaderBarBGColor, color: Colors.TableHeaderTextColor }}><div className='eMed_sortable_center' id="eMed_tbl_headtext">{t("DosageType")}</div></TableCell>
                  <TableCell className='eMed_tbl_headwidth_small' id="eMed_nonsticky_head" sx={{ bgcolor: Colors.TableHeaderBarBGColor, color: Colors.TableHeaderTextColor }}><div className='eMed_sortable_center' id="eMed_tbl_headtext">{t("Strength")}</div></TableCell>
                  <TableCell className='eMed_tbl_headwidth_small' id="eMed_nonsticky_head" sx={{ bgcolor: Colors.TableHeaderBarBGColor, color: Colors.TableHeaderTextColor }}>
                    <div className=' eMed_sortable_center'>
                      <div id="eMed_tbl_headtext">{t("ExpiryDate")}</div>
                      <div onClick={() => { sorting("expiry_date", this.state.ExpiryDateSortOrder) }}>{SortIcon(this.state.ExpiryDateSortIcon)}</div>
                    </div>
                  </TableCell>
                  <TableCell className='eMed_tbl_headwidth_small id="eMed_nonsticky_head"' sx={{ bgcolor: Colors.TableHeaderBarBGColor, color: Colors.TableHeaderTextColor }}>
                    <div className='eMed_sortable_center'>
                      <div id="eMed_tbl_headtext">{t("AvailQuantity")}</div>
                    </div>
                  </TableCell>
                </TableRow>
              </TableHead>
              {filtereddata.length > 0 ? filtereddata.slice(this.state.page * this.state.rowsPerPage, this.state.page * this.state.rowsPerPage + this.state.rowsPerPage)
                .map((data, index) => {
                  return (
                    <TableBody>
                      <TableRow>
                        <TableCell align='center' id='eMed_tbl_bodytext' sx={{ bgcolor: Colors.TableBody, color: Colors.TableProfilDetails }}>{index + 1}</TableCell>
                        <TableCell align='left' id='eMed_tbl_bodytext' sx={{ bgcolor: Colors.TableBody, color: Colors.TableProfilDetails }}>
                          {data.vendor_name.length > 12 ?
                            <Tooltip placement="top" title={data.vendor_name} disableInteractive>
                              <div id='eMed_tbl_bodytext'>{data.vendor_name.slice(0, 12) + '...'}</div>
                            </Tooltip> : `${data.vendor_name}`}
                        </TableCell>
                        <TableCell align='center' id='eMed_tbl_bodytext' sx={{ bgcolor: Colors.TableBody, color: Colors.TableProfilDetails }}>{data.batch_no}</TableCell>
                        <TableCell align='left' id='eMed_tbl_bodytext' sx={{ bgcolor: Colors.TableBody, color: Colors.TableProfilDetails }}>
                          {data.brand_name.length > 12 ?
                            <Tooltip placement="top" title={data.brand_name} disableInteractive>
                              <div id='eMed_tbl_bodytext'>{data.brand_name.slice(0, 12) + '...'}</div>
                            </Tooltip> : `${data.brand_name}`}
                        </TableCell>
                        <TableCell align='center' id='eMed_tbl_bodytext' sx={{ bgcolor: Colors.TableBody, color: Colors.TableProfilDetails }}>{DosageType(data.dosage_type)} </TableCell>
                        <TableCell align='center' id='eMed_tbl_bodytext' sx={{ bgcolor: Colors.TableBody, color: Colors.TableProfilDetails }}>{data.dosage_strength}</TableCell>
                        <TableCell align='center' id='eMed_tbl_bodytext' sx={{ bgcolor: Colors.TableBody, color: Colors.TableProfilDetails }}>{data.expiry_date}</TableCell>
                        <TableCell align='center' id='eMed_tbl_bodytext' sx={{ bgcolor: Colors.TableBody, color: Colors.TableProfilDetails }}>
                          <div id='eMed_tbl_bodytext'>{data.available_quantity}</div>
                        </TableCell>
                      </TableRow>
                    </TableBody>
                  )
                }) :
                <div id='eMed_Norecords' style={{ color: Colors.TableHeaderTextColor }}>
                  {t("NoRecords")}
                </div>}
            </Table>
          </TableContainer>
          <TablePagination
            component='div'
            id="eMed_Table_Pagination"
            sx={{
              color: Colors.Pagination
            }}
            rowsPerPageOptions={[5, 10, 15]}
            count={filtereddata.length}
            rowsPerPage={this.state.rowsPerPage}
            page={this.state.page}
            onPageChange={this.handleChangePage}
            onRowsPerPageChange={this.handleChangeRowsPerPage}
          />
        </Card>
        {this.state.datePickerPop ? <FutureDatePicker PopClose={this.PopClose} CustomDates={this.CustomDates} /> : null}
        {
          this.state.dialogBox ?
            <Dialog
              type={"Notification"}
              DialogClose={this.dialogCloseFunction}
              header={"Message"}
              content={this.state.ErrorMsg}
              icon={<img className="eMed_dilboxAnimations" alt="Warning" src={Failed} />}
              secondary={"Close"}
              closeButton={this.dialogCloseFunction}
            /> : null
        }

      </div>
    )
  }
}
export default withTranslation()(ExpiryStock);